import type { AssignmentSummaryResponse } from '../../api/types';

/**
 * Driver Accept on the Assignment card (#290, PRODUCT_RULES R17, API R22).
 * Accept only acknowledges the trip: it is shown whenever the API sent a time,
 * a "Not accepted" wait only while the trip is ASSIGNED, and nothing otherwise.
 * Older API responses have no field at all; that is treated like null.
 */
export type DriverAcceptance = { kind: 'accepted'; at: string } | { kind: 'waiting' };

export function driverAcceptance(
  shipmentStatus: string,
  assignment: Partial<Pick<AssignmentSummaryResponse, 'driverAcceptedAt'>> | null | undefined,
): DriverAcceptance | null {
  if (!assignment) return null;
  if (assignment.driverAcceptedAt) return { kind: 'accepted', at: assignment.driverAcceptedAt };
  return shipmentStatus === 'ASSIGNED' ? { kind: 'waiting' } : null;
}

/** DD Mon YYYY, HH:mm in IST (UX principle 4, engineering principle 3), e.g. "01 Nov 2026, 01:30". */
export function formatAcceptedAt(iso: string): string {
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Kolkata',
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    })
      .formatToParts(new Date(iso))
      .map((p) => [p.type, p.value]),
  );
  return `${parts.day} ${parts.month} ${parts.year}, ${parts.hour}:${parts.minute}`;
}
